<template>
  <v-card class="fill-height text-left d-flex flex-column dsfr" outlined>
    <v-card-item>
      <v-card-title class="font-weight-bold">
        {{ eatingExperience.title }}
      </v-card-title>
      <v-card-subtitle>
        {{ eatingExperience.descriptionGeneral }}
      </v-card-subtitle>
      <v-card-subtitle class="text-muted">
        {{ eatingExperience.descriptionInfluence }}
      </v-card-subtitle>
    </v-card-item>

    <v-card-text class="py-2">
      <p class="mb-1">
        <strong>Durée :</strong>
        {{ eatingExperience.durationInDay }} jours
      </p>
      <p class="mb-1">
        <strong>Conditions :</strong>
        {{ eatingExperience.conditions }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    eatingExperience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
}
</script>

<style scoped>
.study-card {
  max-width: 400px;
  border-radius: 8px;
}

.v-card-title {
  font-size: 1.25rem;
  color: #1e88e5; /* Couleur principale */
}

.v-card-subtitle {
  font-size: 0.9rem;
  color: #757575; /* Couleur secondaire (gris) */
}

.v-card-text p {
  margin: 0;
  color: #424242; /* Texte principal */
}

.v-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-btn {
  background-color: #e3f2fd; /* Fond bleu clair */
}
.v-btn:hover {
  background-color: #bbdefb; /* Fond bleu plus sombre au hover */
}
</style>
